import { gql } from '@apollo/client';

const UPDATE_WEBSITE = gql`
  mutation UpdateUserProfile($input: UpdateUserProfileInput!) {
    updateUserProfileV2(input: $input) {
      personalInfo {
        webLinks {
          website
        }
      }
    }
  }
`;

export default UPDATE_WEBSITE;
